import floodfill from "../images/floodfill.png";
import pencil from "../images/pencil.png";

const tools = [
  { toolType: "pencil", image: pencil },
  { toolType: "flood-fill", image: floodfill },
];

export default tools;